import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface ArticleForm {
  id: string;
  title: string;
  sourceUrl: string;
  content: string;
  imageUrl: string;
  author: string;
  summary: string;
  publishedAt: string;
  tags: string[];
  isFeatured: boolean;
  isActive: boolean;
  isPublic: boolean;
  isGlobal: boolean;
}

class Article {
  fetchArticles = async (
    isGlobal: boolean,
    pageNumber: number,
    pageSize: number,
    keyword?: string,
    organisationId?: string,
    tag?: string,
    recaptchaToken?: string
  ) => {
    const response = await serviceDirectoryApiClient.get(`articles`, {
      params: {
        pageNumber,
        pageSize,
        isGlobal,
        searchText: keyword,
        tag,
      },
      headers: {
        organisationId,
        recaptchatoken: recaptchaToken,
      },
    });
    return response.data;
  };

  fetchArticleBySlug = async (slug: string, recaptchaToken?: string) => {
    const response = await serviceDirectoryApiClient.get(`articles/${slug}`, {
      headers: {
        recaptchatoken: recaptchaToken,
      },
    });
    return response.data;
  };

  createArticle = async (article: ArticleForm, organisationId: string) => {
    const formData = this.formDataArticle(article);
    const response = await serviceDirectoryApiClient.post('articles', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        organisationId,
      },
    });

    return response.data;
  };

  updateArticle = async (id: string, article: ArticleForm, organisationId: string) => {
    const formData = this.formDataArticle(article);
    const response = await serviceDirectoryApiClient.put(`articles/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        organisationId,
      },
    });
    return response.data;
  };

  deleteArticle = async (id: string, organisationId: string) => {
    const response = await serviceDirectoryApiClient.delete(`articles/${id}`, {
      headers: { organisationId },
    });
    return response.data;
  };

  private formDataArticle = (article: ArticleForm) => {
    const formData = new FormData();
    formData.append('title', article.title);
    if (typeof article.imageUrl === 'string') {
      formData.append('imageUrl', article.imageUrl);
    } else {
      formData.append('imageFile', article.imageUrl);
    }
    formData.append('content', article.content ?? '');
    formData.append('sourceUrl', article.sourceUrl ?? '');
    formData.append('summary', article.summary ?? '');
    formData.append('author', article.author ?? '');
    formData.append('publishedAt', article.publishedAt ?? '');
    formData.append('tags', article.tags.join(','));
    formData.append('isFeatured', article.isFeatured.toString());
    formData.append('isActive', article.isActive.toString());
    formData.append('isPublic', article.isPublic.toString());
    formData.append('isGlobal', article.isGlobal.toString());
    return formData;
  };
}

export const ArticleInstance = new Article();
